import { takeLatest } from 'redux-saga/effects';
import { deleteNotifications, getNotifications } from './NotificationsSagas';
import { NOTIFICATIONS_ACTION_TYPES } from '../actionTypes';

export function* getNotificationsWatcher() {
  yield takeLatest(NOTIFICATIONS_ACTION_TYPES.GET.IN_PROGRESS, getNotifications);
  yield takeLatest(NOTIFICATIONS_ACTION_TYPES.DELETE.IN_PROGRESS, deleteNotifications);
}
